module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./BeanHomeView.js"));
	}, "BeanHomeView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=BeanHomeView!./src/pages/PunchClock/Bean/BeanHome/BeanHomeView.js
// module id = 2252
// module chunks = 367